import {
    Button,
    Input,
    InputNumber,
    Radio,
    Typography,
    Space,
    Modal,
    Row,
    Col
} from "antd";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";
import { useEffect, useState, useContext } from "react";
import { PublicContext } from "../PublicContext";
import "../../styles/custom.css";
import { useNavigate } from "react-router-dom";

export default function UpsellUtensilModal({ visible, onClose }) {
    const navigate = useNavigate();
    const {
        upsell,
        products,
        setSpinning,
        cart,
        setCart,
        cartNum,
        setCartNum,
        setCartPrice,
        openNotification,
        selectedStore
    } = useContext(PublicContext);
    const { TextArea } = Input;
    const [orderInstruction, setOrderInstruction] = useState("");
    const { Paragraph, Title } = Typography;

    const [instructionError, setInstructionError] = useState("");
    async function addToCart(product) {
        //console.log(menuItemProp);
        setSpinning(true);
        if (window.gtag) {
            window.gtag('event', 'UpsellAddToCart', {
                event_category: 'Upsell',
                event_label: 'UpsellAddToCart: ' + product.productName,
            });
        }
        let postData = [{
            ProductCode: product.productCode,
            ProductName: product.productName,
            Quantity: 1,
            SingleProductPrice: product.price,
            IsUpsell: true
        }];

        await fetch("api/Carts/add-to-cart", {
            // await fetch("api/<OrderController>", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-type": "application/json",
            },
            body: JSON.stringify({
                Cart: postData,
                OrderType: sessionStorage.getItem("deliveryOrPickUp"),
                StoreCode: JSON.parse(sessionStorage.getItem("selectedStore")).storeCode
            }),
        })
            .then(async (response) => {
                setSpinning(false);
                // console.log(response);
                const responseData = await response.json();
                //console.log(responseData);
                setCart(responseData);

                const totalQuantity = responseData.reduce(
                    (acc, obj) => acc + obj.quantity,
                    0
                );

                const numberAdded = totalQuantity - cartNum;

                setCartNum(totalQuantity);
                setCartPrice(responseData[0].orderSubtotal);

                if (numberAdded > 1) {
                    openNotification("success", 1 + " item and promotion are added!");
                }
                else {
                    openNotification("success", 1 + " item is added!");
                }

                localStorage.setItem("cart", JSON.stringify(responseData));
            })
            .catch((error) => {
                setSpinning(false);
                openNotification("error", "Something went wrong. Please try again.");
                console.error(error);
                // setSubmitDistabled(false);
            });
    };

    function getRandomSample(array, size) {
        const shuffled = array.slice();
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
        }
        return shuffled.slice(0, size);
    }

    function RenderUpsellList() {
        const [randomUpsells, setRandomUpsells] = useState([]);

        useEffect(() => {
            // Assuming 'cart' contains product codes of items already in the cart
            if (cart != null) {
                const cartProductCodes = cart.map(item => item.productCode);

                // Filter out products that are already in the cart and are sticky
                const filteredUpsell = upsell.filter(us => !cartProductCodes.includes(us.productCode) && !us.isSticky);

                // Get a random sample of 3 products from the filtered upsell list
                const randomSample = getRandomSample(filteredUpsell, 3);

                // Add sticky upsells to the beginning of the random sample
                randomSample.splice(0, 0, ...upsell.filter(us => us.isSticky));

                setRandomUpsells(randomSample);
            }
        }, [upsell, cart]);

        return (
            <>
                {randomUpsells.length > 0 &&
                    <>
                        <hr></hr>
                        <Typography.Title level={4} tag="h1" className="fw-bold mb-0 text-black">
                            You May Like {randomUpsells.length >= 2 ? <>These</> : <>This</>}
                        </Typography.Title>

                        {randomUpsells.map((us) => {
                            console.log(us);
                            let upsellProduct = products.find(p => p.productCode === us.productCode);
                            console.log(upsellProduct);
                            return (
                                <Row key={"upsell_" + us}>
                                    <div xs={24} sm={24} md={24} lg={24} style={{ padding: "5px" }} className="upsellCol menuProductHorizontal">
                                        <div className="menuProductHorizontalImg">
                                            <img
                                                alt={upsellProduct.productName}
                                                src={`https://takeoutpictures.blob.core.windows.net/weborderpictures/medium/${encodeURIComponent(upsellProduct.pictureURL)}`}
                                                className="rounded-3 menuProductHorizontalImg"
                                                style={{ height: "60px", width: "auto", paddingTop: "-10px" }}
                                                onError={({ currentTarget }) => {
                                                    currentTarget.style.display = 'none';
                                                }}
                                            />
                                        </div>

                                        <div className="menuProductHorizontalText">
                                            <Row>
                                                <Paragraph ellipsis={true ? { rows: 2 } : false} className="text-black flex-wrap productName">
                                                    {upsellProduct.productName}
                                                </Paragraph>
                                            </Row>

                                            <Row>
                                                <Title tag="h6" level={5} className="mb-0">
                                                    $ {upsellProduct.price}
                                                </Title>
                                            </Row>
                                        </div>

                                        <div>
                                            <Button
                                                color="link"
                                                className="px-2 qty-btn"
                                                shape="circle"
                                                style={{ fontSize: '16px', background: "#dedede" }}
                                                onClick={() => {
                                                    addToCart(upsellProduct);
                                                }}
                                                icon={<PlusOutlined style={{ fontSize: '18px' }} />}
                                            />
                                        </div>
                                    </div>
                                </Row>
                            );
                        })}
                    </>
                }
            </>
        );
    }
    //<Col key={"upsell_" + us} xs={24} sm={24} md={24} lg={24} style={{ padding: "5px" }} className="upsellCol">
    //    <Row
    //        key={upsellProduct.getProductCode}
    //        value={upsellProduct.getProductCode}
    //        className="upsellRow"
    //    >
    //        <Col>
    //            <div className="menuProductHorizontalImg">
    //                <img
    //                    alt={upsellProduct.productName}
    //                    src={`https://takeoutpictures.blob.core.windows.net/weborderpictures/medium/${encodeURIComponent(upsellProduct.pictureURL)}`}
    //                    className="rounded-3 menuProductHorizontalImg"
    //                    style={{ height: "60px", width: "auto", paddingTop: "-10px" }}
    //                    onError={({ currentTarget }) => {
    //                        currentTarget.style.display = 'none';
    //                    }}
    //                />
    //            </div>
    //        </Col>
    //        <Col span={14}>
    //            <Typography.Title level={5} className="text-black flex-wrap">
    //                {upsellProduct.productName}
    //            </Typography.Title>
    //            <Typography.Title level={5} className="mt-1">
    //                $ {upsellProduct.price}
    //            </Typography.Title>
    //        </Col>
    //        <Col>
    //            <Button
    //                color="link"
    //                className="px-2 qty-btn"
    //                shape="circle"
    //                style={{ fontSize: '16px', background: "#dedede"}}
    //                onClick={() => {
    //                    addToCart(upsellProduct);
    //                }}
    //                icon={<PlusOutlined style={{ fontSize: '18px' }} />}
    //            />
    //        </Col>
    //    </Row>
    //    <hr />
    //</Col>

    return (
        <>
            <Modal
                title={
                    <Typography.Title level={2}>Would you like to add to your order?</Typography.Title>
                }
                footer={
                    <div style={{ textAlign: 'center' }}>
                        <Button
                            className="upsellCheckout-btn btn-primary"
                            shape="round"
                            onClick={() => { onClose(); navigate('../checkout') }}
                        >
                            Check Out
                        </Button>
                    </div>
                }
                visible={visible}
                onCancel={onClose}
                scrollable={true}
                // key={placement}
                className="upsellUtensilModal"
            >
                <Typography.Title level={4} tag="h1" className="fw-bold mb-0 text-black">
                    Special Instructions
                </Typography.Title>
                <TextArea
                    rows={3}
                    className="specialInstructionTextArea"
                    placeholder="Let us know which utensils, napkins, straws and condiments you would like to have and any special instructions to the order."
                    value={orderInstruction}
                    onChange={(event) => {
                        const value = event.target.value;
                        const asciiValue = value.replace(/[^\x00-\x7F]/g, '');
                        if (value !== asciiValue) {
                            setInstructionError("Please only enter standard alphanumeric characters.");
                        }
                        else {
                            setInstructionError("");
                            setOrderInstruction(asciiValue);
                            sessionStorage.setItem(
                                "orderInstructions",
                                asciiValue
                            );
                        }
                    }}
                ></TextArea>
                <Typography style={{ color: "red" }}>{instructionError}</Typography>
                {RenderUpsellList()}
            </Modal>
        </>
    );
}
